import { CommonsModule } from '@commons/commons.module'
import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { ChatDetailComponent } from './chat-detail/chat-detail.component'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { ModalCommonsModule } from '@modal/modal-commons/modal-commons.module'
import { ChatItemComponent } from './chat-item/chat-item.component'
import { ChatModule } from '@commons/chat/chat.module'
import { PipeModule } from '@app/pipes/pipe.module'

const DECLARES = [ChatDetailComponent]

@NgModule({
    imports: [CommonModule, ReactiveFormsModule, FormsModule, CommonsModule, ModalCommonsModule, ChatModule, PipeModule],
    exports: [...DECLARES, ChatItemComponent],
    declarations: [...DECLARES, ChatItemComponent],
})
export class AppComponentModule {
}



// WEBPACK FOOTER //
// ./src/app/client-app/app-component/app-component.module.ts